import React from 'react';
import { motion } from 'framer-motion';
import { Award, BadgeDollarSign, Zap, ThumbsUp } from 'lucide-react';
const reasons = [{
  title: 'Licensed Professionals',
  description: 'Fully licensed, bonded, and insured plumbers you can trust in your home or business.',
  icon: Award
}, {
  title: 'Upfront Honest Pricing',
  description: 'No hidden fees or surprise charges. We provide clear estimates before any work begins.',
  icon: BadgeDollarSign
}, {
  title: 'Fast Response Times',
  description: 'When you have a plumbing emergency, we dispatch our team quickly to minimize damage.',
  icon: Zap
}, {
  title: 'Workmanship Guarantee',
  description: 'We stand behind our work. If it is not done right, we will make it right. Guaranteed.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-20 lg:py-28 bg-brand-gray border-y border-gray-200" data-id="element-340">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-342">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5 relative" data-id="element-343">
            <div className="relative h-[500px] lg:h-[650px] rounded-md overflow-hidden shadow-xl" data-id="element-344">
              <div className="absolute inset-0 bg-brand-navy/10 mix-blend-multiply z-10" data-id="element-345"></div>
              <img src="https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=1000&auto=format&fit=crop" alt="Professional plumber working on pipes under a sink" className="w-full h-full object-cover object-center" data-id="element-346" />
            </div>
            {/* Decorative Accent */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-red rounded-md -z-10" data-id="element-347"></div>
          </motion.div>

          {/* Content Column */}
          <div className="lg:col-span-7" data-id="element-348">
            <div className="mb-12 text-center lg:text-left" data-id="element-349">
              <h2 className="text-brand-red font-bold tracking-widest uppercase text-sm mb-3" data-id="element-350">
                The Done Right Difference
              </h2>
              <h3 className="text-4xl md:text-5xl font-display font-bold text-brand-navy uppercase" data-id="element-351">
                Why Choose Us?
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 lg:gap-10" data-id="element-352">
              {reasons.map((reason, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-white p-6 rounded-md shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-353">
                  <div className="w-14 h-14 bg-brand-gray rounded-md flex items-center justify-center mb-5 border border-gray-200" data-id="element-354">
                    <reason.icon className="w-7 h-7 text-brand-red" data-id="element-355" />
                  </div>
                  <h4 className="text-xl font-display font-bold text-brand-navy uppercase mb-3" data-id="element-356">
                    {reason.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-357">
                    {reason.description}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}